import { CountryCodes } from '../constants';
import fetchEcomm from '../util/fetchEcomm';
import fetchApi from '../util/fetchApi';
import fetchCountryCode from './geolocation';
import { getAllFlagsState } from './feature-flags';


/**
 * Attempts to fetch user.
 * Sends a request to server with cookies to validate against.
 * @param {Object} [options] Options to pass to fetch()
 * @returns {Promise} Always resolves. Will either resolve with
 * js object if user session, or null if no user session.
 */
export async function fetchUser(options = {}) {
  try {
    const res = await fetchApi('/user/v1/profile', options);
    const json = await res.json();
    return { ...json, is_admin: (json.roles && json.roles.length > 0) };
  } catch (e) {
    return null;
  }
}

/**
 * Attempts to fetch referral info.
 * /storefront/api uses a cookie to check for referral codes.
 * However, if a referral_code kid is passed through, it will 
 * use this to set a new cookie.
 * Passing through the kid allows us to set referrals from any gf-dotcom page 
 * using query params.
 */
export const fetchReferralInfo = async (kid) => {
  let url = `/storefront/api/referral`;

  // only apply if kid is defined
  if (kid) {
    const params = new URLSearchParams({
      referral_code: kid,
    });

    url += `?${String(params)}`;
  }

  try {
    const res = await fetchEcomm(url);
    const json = await res.json();
    return json;
  } catch (e) {
    return {};
  }
};

/**
 * Fetch a list of products
 *  This has now been modified to get products for different countries
 * @param {Object} context The context object from getInitialProps
 * @param {Object} [options]
 * @param {String} options.forceCountryCode Don't fetch country code, 
 * just force one
 * @returns {Promise<Object>} Returns the promise to get you the GF products
 */
export const fetchProducts = async (context, options = { forceCountryCode: null }) => {
  try {
    const flagStates = await getAllFlagsState();
    const { 'space-monkeys': ENABLED_COUNTRIES } = flagStates;
    // Get the requested country code for this session from cloudfront headers 
    // (client or server-side)
    let countryCode = options.forceCountryCode ? 
      options.forceCountryCode : await fetchCountryCode(context);
    if (!ENABLED_COUNTRIES?.includes(countryCode)) {
      countryCode = CountryCodes.US;
    }
    const response = await fetchApi(`/ecom/v1/shopify_products?country=${countryCode}`);
    const json = await response.json();
    return json.products;
  } catch (e) {
    console.log(e)
    return {};
  }
};
